
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/detroit-shade",
      function () {
        return require("private-next-pages/stories/detroit-shade.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/detroit-shade"])
      });
    }
  